import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import Header from '../../Common/Layout/Header';
import AdminTabs from './AdminTabs';
import { format } from 'date-fns';

const ClientSubscriptions = () => {
    const { user, loading: authLoading } = useAuth();
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const getClients = useCallback(async (currentPage) => {
        if (!user) return;
        setLoading(true);
        try {
            const resourceUrl = `${config.GETCOMPANIES}?companyType=CLIENT&PageNumber=${currentPage}&PageSize=${pageSize}`;
            const response = await apiService.getAll(resourceUrl);
            console.log("Fetched client companies:", response);
            setClients(response.data || []);
            setTotalPages(response.totalPages || 0);
            setTotalRecords(response.totalRecords || 0);
            setPageNumber(response.pageNumber || 1);
        } catch (error) {
            console.error("Failed to fetch client companies:", error);
            setClients([]);
        } finally {
            setLoading(false);
        }
    }, [user, pageSize]);

    useEffect(() => {
        if (!authLoading && user) {
            getClients(pageNumber);
        }
    }, [user, authLoading, pageNumber, getClients]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return format(new Date(dateString), 'dd MMM, yyyy hh:mm a');
    };

    // KEY CHANGE 2: Added Pagination Logic from your reference
    const GetPageData = (number) => {
        if (number > 0 && number <= totalPages) {
            setPageNumber(number);
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <li className={`page-item ${pageNumber === i ? "active" : ""}`} key={i}>
                    <Link to="#" className="page-link" onClick={() => GetPageData(i)}>{i}</Link>
                </li>
            );
        }
        return pageNumbers;
    };


    if (authLoading) return <p>Loading...</p>;
    if (!user) {
        navigate("/");
        return null;
    }

    return (
        <>
            <Header />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="p-2">
                                <AdminTabs pageName="CLIENTSUBSCRIPTIONS" />
                            </div>
                            
                            {/* KEY CHANGE 1: Removed the entire card-header with the search bar */}
                            
                            <div className="card-body">
                                <div className="table-responsive table-card">
                                    <table className="table align-middle table-hover">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Company / Brand</th>
                                                <th>Contact</th>
                                                <th>Plan</th>
                                                <th>Connects Left</th>
                                                <th>Expires On</th>
                                                <th>Status</th>
                                                {/* Action column removed */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr><td colSpan="6" className="text-center py-4">Loading clients...</td></tr>
                                            ) : clients.length > 0 ? (
                                                clients.map(client => (
                                                    <tr key={client.companyId}>
                                                        <td>
                                                            <div><strong>{client.companyName}</strong></div>
                                                            <small className="text-muted">{client.brandName || '-'}</small>
                                                        </td>
                                                        <td>
                                                            <div>{client.email}</div>
                                                            <small className="text-muted">{client.phoneNumber}</small>
                                                        </td>
                                                        <td>
                                                            <span className="badge bg-primary">{client.planType || 'N/A'}</span>
                                                        </td>
                                                        <td>{client.connects}</td>
                                                        <td>{formatDate(client.endDate)}</td>
                                                        <td>
                                                            <span className={`badge ${client.isActive ? 'bg-success' : 'bg-danger'}`}>
                                                                {client.isActive ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </td>
                                                        {/* Action td removed */}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="6" className="text-center py-4">No clients found.</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* KEY CHANGE 3: Added Pagination section */}
                                {clients.length > 0 && (
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                            Showing <span className="fw-semibold">{clients.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                                                <Link to="#" className="page-link" onClick={() => GetPageData(pageNumber - 1)}>Previous</Link>
                                            </li>
                                            {renderPageNumbers()}
                                            <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`}>
                                                <Link to="#" className="page-link" onClick={() => GetPageData(pageNumber + 1)}>Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClientSubscriptions;